import { Chapter, MaskedLine, Reveal } from "../components/motion";
import { config } from "../config/siteConfig";

const Testimonials = () => {
  const hasTestimonials = config.testimonials.length > 0;

  return (
    <section
      id="readers"
      data-testid="testimonials-section"
      className="bg-white text-[#08162B] py-24 lg:py-36"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Chapter index="07" label="Reader Results" />

        <h2 className="mt-10 font-display tracking-[0.02em] leading-[1.02] text-[clamp(2.2rem,5.5vw,4.5rem)] max-w-4xl">
          <MaskedLine delay={0.1}>REAL READERS. REAL WORK.</MaskedLine>
        </h2>

        <Reveal delay={0.2} className="mt-6 max-w-2xl">
          <p className="text-lg sm:text-xl leading-relaxed text-[#5A6E85]">
            What readers are saying about The Ecom Bible.
          </p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {hasTestimonials
            ? config.testimonials.map((t, i) => (
                <Reveal key={i} delay={i * 0.1}>
                  <figure
                    data-testid={`testimonial-${i + 1}`}
                    className="border border-[#08162B]/12 border-t-2 border-t-[#D4AF37] bg-white p-8 h-full flex flex-col"
                  >
                    <span aria-hidden className="font-sans font-extrabold text-6xl leading-[0.6] text-[#D4AF37]">&ldquo;</span>
                    <blockquote className="mt-2 font-condensed text-base sm:text-lg leading-relaxed flex-1">
                      {t.quote}
                    </blockquote>
                    <figcaption className="mt-6 font-mono text-[11px] uppercase tracking-[0.2em] text-[#5A6E85]">
                      {t.name}
                      {t.role ? ` — ${t.role}` : ""}
                    </figcaption>
                  </figure>
                </Reveal>
              ))
            : [1, 2, 3].map((slot) => (
                <Reveal key={slot} delay={slot * 0.08}>
                  <div
                    data-testid={`testimonial-slot-${slot}`}
                    className="flex h-full min-h-[220px] flex-col items-center justify-center gap-4 border border-dashed border-[#08162B]/25 bg-[#F7F8FA] p-8 text-center"
                  >
                    <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#5A6E85]">
                      Reader testimonial
                    </span>
                    <span className="font-display text-2xl tracking-[0.08em] text-[#08162B]/30">Slot {String(slot).padStart(2, "0")}</span>
                    <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#5A6E85]/60">
                      Reserved for a verified reader
                    </span>
                  </div>
                </Reveal>
              ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
